// ColorPickerVStack.tsx
import React from "react";
import {
  VStack,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
} from "@chakra-ui/react";
import { SketchPicker, ColorResult } from "react-color";
import { ColorType } from "src/utils/types";

interface ColorPickerVStackProps {
  label: string;
  colorValue?: string;
  colorType: ColorType;
  activeColorType: ColorType | "";
  isOpen: boolean;
  onClose: () => void;
  handleColorPickerOpen: (colorType: ColorType) => void;
  handleColorChange: (color: ColorResult, colorType: ColorType) => void;
}

const ColorPickerVStack: React.FC<ColorPickerVStackProps> = ({
  label,
  colorValue,
  colorType,
  activeColorType,
  isOpen,
  onClose,
  handleColorPickerOpen,
  handleColorChange,
}) => {
  const isThisPopoverOpen = isOpen && activeColorType === colorType;

  return (
    <VStack align="flex-start" spacing={1}>
      <Text color="gray.600">{label}</Text>
      <Popover isOpen={isThisPopoverOpen} onClose={onClose}>
        <PopoverTrigger>
          <Button
            w="100px"
            h="30px"
            p={0}
            onClick={() => handleColorPickerOpen(colorType)}
            border="1px solid"
            _hover={{ opacity: 0.8 }}
            bg={colorValue}
          >
            <Text fontSize="xs" color={colorValue ? "black" : colorValue}>
              {colorValue}
            </Text>
          </Button>
        </PopoverTrigger>
        <PopoverContent w="fit-content">
          <PopoverBody>
            <SketchPicker
              color={colorValue}
              onChange={(newColor) => handleColorChange(newColor, colorType)}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </VStack>
  );
};

export default ColorPickerVStack;
